import "./_style.css"
import * as React from "react";
import BreadCrumbs from "../../components/BreadCrumbs";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {NavLink, useParams} from "react-router-dom";
import {ICatGridFilter, ICatGridQuery} from "../../helpers/Interfaces";
import PaginationBar from "../../components/PaginationBar";
import Footer from "../../components/Footer";
import ProdsFilterBlock from "./ProdsFilterBlock";


// Header of Products' grid table
function ProdsGridHeader(props:any) {

    return (
        <div className="grid-base grid-header prods-grid-columns">
            <div>#</div>
            <div>Brand</div>
            <div>MPN</div>
            <div>Category</div>
            <div>Feats #</div>
            <div>Last update</div>
        </div>
    )
}

function ProdGridRow(props: any) {

    const {num, prodObj} = props

    let prodLink: string = `../details/${prodObj.prodID}`

    return (
        <div className="grid-base grid-row prods-grid-columns">
            <div>{num}</div>
            <div>{prodObj.brandName}</div>
            <div><NavLink to={prodLink}>{prodObj.mpn}</NavLink></div>
            <div>{prodObj.catName}</div>
            <div>{prodObj.featsNum}</div>
            <div>{prodObj.lastUpdate}</div>
        </div>
            )
}

export default function ProdsList() {

    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)
    // console.log(userPermissions)

    const {prjid, page_num} = useParams()


    // when user clicks "Back" in browser than filters are preserved
    let preFilter = localStorage.getItem("filterProds")
    let storFilter: ICatGridFilter | any = null
    if (preFilter) {
        storFilter = JSON.parse(preFilter)
    }

    const [filterObj, setFilterObj] = useState<any>({
        brand: '',
        mpn: '',
        ean: '',
        catName: '',
        catID: ''
    })
    // console.log('Filter object:', filterObj)

    const [pageData, setPageData] = useState({
        firstPostIndx: 1,
        totalPosts: 0,
        dataList: [],
        currentPage: null
    })

    const [queryObj, setQueryObj] = useState<ICatGridQuery>({
        postsPerPage: 20,
        projID: prjid,
        // currentPage: +(page_num || 1),
        currentPage: isNaN(+(page_num || 1)) ? 1 : +(page_num || 1),
        filterObj: storFilter ? storFilter : filterObj
    })
    // console.log('Query obj:', queryObj)


    useEffect(() => {

        // re-sets filterObj for when user came from "Back" button in browser
        if (storFilter) {
            setFilterObj(storFilter)
        }

        getProdsData()
    }, [queryObj])

    let getProdsData = async () => {
        let response = await fetch(`${serverIP}/getprodslist/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(queryObj),
        })
        let data = await response.json()

        if (response.status === 200) {
            setPageData(prevState => {
                return {
                    ...prevState,
                    firstPostIndx: data.firstPostIndx,
                    totalPosts: data.totalPosts,
                    dataList: data.pagePosts,
                    currentPage: data.currentPage,
                }
            })
        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const paginate = (pageNumber: number) => setQueryObj(prevState => {
        return {...prevState, currentPage: pageNumber}
    });


    const rowElements = pageData.dataList.map((item, index) => {
        return <ProdGridRow
            key={index + pageData.firstPostIndx}
            num={index + 1 + pageData.firstPostIndx}
            prodObj={item}
        />
    })

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Products List', 'link': ''}
    ]

    return(
        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <ProdsFilterBlock
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                queryObj={queryObj}
                setQueryObj={setQueryObj}
            />

            <div className="count-and-paginator">
                <div style={{marginLeft: '10px'}}><small><i>Listing {pageData.totalPosts} items</i></small></div>

                <PaginationBar
                    postsPerPage={queryObj.postsPerPage}
                    totalPosts={pageData.totalPosts}
                    paginate={paginate}
                    currentPage={queryObj.currentPage}
                    parentURL={`../`}
                />
            </div>


            <ProdsGridHeader/>
            <div className="grid-rows-container">
                {rowElements}
            </div>

            <PaginationBar
                postsPerPage={queryObj.postsPerPage}
                totalPosts={pageData.totalPosts}
                paginate={paginate}
                currentPage={queryObj.currentPage}
                parentURL={`../`}
            />

            <Footer/>

        </>
    )
}